var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#4A4A4A;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,16.6l1.4-1.9c-0.3-1.2,0-2.5,0.9-4C7.1,10.1,7.5,9.5,8,9c0.3,0.6,0.9,1.7,1.1,2.1c0-0.5-0.3-2.1,0-3.3 c1-1,2.2-1.9,3.5-2.7c0.1,0.6,0.3,1.8,0.4,2.1c0.1-0.4,0.3-2,0.8-2.9c1.9-1,3.8-1.8,5.5-2.1c-0.5,1.3-1.1,3-2,4.7 C16.5,7.5,15,8,14.4,8.1c0.5,0.1,1.5,0.2,2.2,0.2c-0.2,0.3-0.4,0.7-0.6,1c-0.5,0.9-1.1,1.7-1.6,2.4c-0.9,0.5-2.4,0.8-2.9,0.9 c0.4,0.2,1.2,0.4,1.8,0.5c-1.7,1.9-3.4,3-4.9,3.2c1.2-2.2,2.2-3.9,2.6-4.5C6.5,15.3,3.8,20.6,2,24l2.5-0.8c0.4-0.8,1.7-3,2.8-4.8 c0.3,0,0.5,0.1,0.8,0.1C15.5,18.4,21.7,3.2,22,0C13.9,0,0.5,9,4.5,16.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseTitle);
export default __webpack_public_path__ + "static/media/Course Title.de09c8d4.svg";
export { ForwardRef as ReactComponent };